import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Button,
  CardMedia,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import Image from "./fondo4.jpg";
import { PreciosContext } from "../hooks/PricesContext";
import * as styles from "../styles/Analisis.js";
import Tag from "./Tag.js";
import useMediaQuery from "@mui/material/useMediaQuery";

export const myStyle = {
  backgroundImage: `url(${Image})`,
  height: "100%",
  minHeight: "90vh",
  marginTop: "0px",
  backgroundSize: "cover",
  width: "100%",
  backgroundRepeat: "no-repeat",
};

const handleOpenNewTab = (ticker) => {
  // Construye una URL con parámetros que representen el "card" seleccionado
  const url = `/new-tab?ticker=${ticker}`; // Por ejemplo, '/new-tab?ticker=AMZN'
  window.open(url, "_blank");
};

const DisclaimerModal = ({ open, onClose, showAcceptButton }) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (showAcceptButton) {
      // Mostrar el botón después de 3 segundos
      const timer = setTimeout(() => {
        setShowButton(true);
      }, 5000);

      return () => clearTimeout(timer); // Limpia el temporizador en la desmontaje del componente
    }
  }, [showAcceptButton]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={styles.modalStyle}
      backdropClick={false}
    >
      <Box sx={styles.modalContainer}>
        {/* Contenido del disclaimer */}
        <Box>
          <Typography variant="h5" sx={{ pr: 1, pl: 1 }}>
            Aviso Legal
          </Typography>
          <br />
          <Typography sx={{ pr: 1, pl: 1 }}>
            Este es un mensaje de descargo de responsabilidad importante.
            Asegúrese de leer y comprender los términos y condiciones antes de
            continuar.
          </Typography>
          <br />
          <Typography sx={{ pr: 1, pl: 1 }}>
            Los objetivos calculados para cada empresa son a base de análisis y
            apreciaciones personales,{" "}
            <span style={{ fontWeight: "bold" }}>
              esto no es un consejo de inversión.
            </span>
          </Typography>
          <br />
          <Typography sx={{ pr: 1, pl: 1 }}>
            Por favor usar la informacion compartida como una guia, es
            importante hacer un analisis personal para poder tomar desiciones.
          </Typography>
        </Box>
        <br />
        <Box sx={styles.buttonModal}>
          {showButton && (
            <Button sx={{ pr: 1 }} onClick={() => onClose()}>
              Aceptar
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

const CustomBox = ({ data, sx }) => {
  return (
    <Box
      sx={{
        ...styles.containerDatos,
        ...sx,
      }}
    >
      {data.map((item) => (
        <Box
          key={item.label}
          sx={{
            ...styles.boxPriceFullScreen,
          }}
        >
          <Typography sx={styles.priceStyle}>{item.label}</Typography>
          {item.tag && (
            <Tag
              text={item.tag.text}
              colorChoice={item.tag.colorChoice}
              sx={styles.priceStyle}
            />
          )}
          {item.value && (
            <Typography
              sx={{
                ...styles.priceStyle,
                ...(item.label === "Diff" ? { color: item.color } : {}),
              }}
            >
              ${item.value}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};

function AnalisisCard({
  ticker,
  target,
  riesgo,
  deuda,
  crecimiento,
  margenes,
  price,
  image,
}) {
  const Diff = ((target - price) / price) * 100;

  const data = [
    { label: "Precio", value: price },
    { label: "Objetivo", value: target },
    {
      label: "Diff",
      value: Diff.toFixed(2) + "%",
      color: Diff * -1 <= 0 ? "green" : "red",
    },
    {
      label: "Riesgo",
      value: "",
      tag: {
        text: riesgo,
        colorChoice:
          riesgo === "Bajo" ? "green" : riesgo === "Medio" ? "orange" : "red",
      },
    },
    {
      label: "Deuda",
      value: "",
      tag: {
        text: deuda,
        colorChoice:
          deuda === "Baja" ? "green" : deuda === "Media" ? "orange" : "red",
      },
    },
    {
      label: "Crecimiento",
      value: "",
      tag: {
        text: crecimiento,
        colorChoice:
          crecimiento === "Alto"
            ? "green"
            : crecimiento === "Medio"
            ? "orange"
            : "red",
      },
    },
    {
      label: "Margenes",
      value: "",
      tag: {
        text: margenes,
        colorChoice:
          margenes === "Altos"
            ? "green"
            : margenes === "Medios"
            ? "orange"
            : "red",
      },
    },
  ];

  const dataMobile = data.filter((item) =>
    ["Precio", "Objetivo", "Diff"].includes(item.label)
  );
  const dataMobile2 = data.filter((item) =>
    ["Riesgo", "Deuda", "Crecimiento", "Margenes"].includes(item.label)
  );

  return (
    <Box sx={styles.styleContainer}>
      <Box sx={styles.cardContainer}>
        <Box sx={styles.cardMedia}>
          <Button
            onClick={() => handleOpenNewTab(ticker)}
            sx={styles.buttonMedia}
          >
            <CardMedia
              component="img"
              image={image}
              sx={{ maxHeight: "120px" }}
            />
          </Button>
        </Box>
        <CustomBox
          data={dataMobile}
          sx={{ display: { xs: "flex", sm: "none" } }}
        />
      </Box>
      <CustomBox
        data={dataMobile2}
        sx={{ display: { xs: "flex", sm: "none" } }}
      />
      <CustomBox data={data} sx={{ display: { xs: "none", sm: "flex" } }} />
    </Box>
  );
}

const Analisis = () => {
  const [disclaimerOpen, setDisclaimerOpen] = useState(true);
  const [filterByName, setFilterByName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const [selectedTickers, setSelectedTickers] = useState([]);

  const { stocks } = useContext(PreciosContext);

  const handleCloseDisclaimer = () => {
    setDisclaimerOpen(false);
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detectar si estamos en una pantalla pequeña (móvil)
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Puedes ajustar este valor según tus necesidades
    };

    // Configurar el evento de escucha del tamaño de la pantalla
    window.addEventListener("resize", handleResize);

    // Llamar al manejador de redimensionamiento para establecer el estado inicial
    handleResize();

    // Limpiar el evento de escucha al desmontar el componente
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Box style={myStyle} sx={styles.containerStyle}>
      <Box sx={styles.cardStyle}>
        <Typography
          sx={{
            fontSize: 25,
            marginLeft: 2,
            color: "white",
            marginBottom: 1.5,
            display: { xs: "none", md: "flex" },
            textAlign: "center",
          }}
        >
          Filtros:
        </Typography>
        <TextField
          sx={styles.textFieldStyle}
          label="Nombre"
          value={filterByName}
          onChange={(e) => setFilterByName(e.target.value)}
        />
        <Button sx={styles.styleButton} onClick={() => setSelectedCategory("")}>
          Todas
        </Button>
        <Button
          sx={styles.styleButton}
          onClick={() => setSelectedCategory("Tecnologico")}
        >
          Tecno
        </Button>
        <Button
          sx={styles.styleButton}
          onClick={() => setSelectedCategory("Financiero")}
        >
          {" "}
          {isMobile ? "Finan" : "Financiero"}
        </Button>
        <Button
          sx={styles.styleButton}
          onClick={() => setSelectedCategory("Consumo")}
        >
          {isMobile ? "Cons" : "Consumo"}
        </Button>
        <Button
          sx={styles.styleButton}
          onClick={() => setSelectedCategory("Commodity")}
        >
          {isMobile ? "O&G" : "Commodity"}
        </Button>
        <Button
          sx={styles.styleButton}
          onClick={() => setSelectedCategory("Industrial")}
        >
          {isMobile ? "Indus" : "Industrial"}
        </Button>
        <Button
          sx={styles.styleButton}
          onClick={() => setSelectedCategory("Farmaceutico")}
        >
          {isMobile ? "Phar" : "Farmaceutico"}
        </Button>
      </Box>
      <DisclaimerModal
        open={disclaimerOpen}
        onClose={handleCloseDisclaimer}
        showAcceptButton={true}
      />
      {stocks
        .sort((a, b) => {
          const aIsAtTop = selectedTickers.includes(a.ticker);
          const bIsAtTop = selectedTickers.includes(b.ticker);

          if (aIsAtTop && !bIsAtTop) return -1;
          if (!aIsAtTop && bIsAtTop) return 1;
          return 0;
        })
        .filter(
          (stock) =>
            (selectedCategory === "" || stock.category === selectedCategory) &&
            (filterByName === "" ||
              stock.name.toLowerCase().includes(filterByName.toLowerCase()))
        )
        .map((stock) => (
          <AnalisisCard
            price={stock.price}
            target={stock.target}
            Ratios={stock.Ratios}
            name={stock.name}
            ticker={stock.ticker}
            image={stock.image}
            riesgo={stock.riesgo}
            deuda={stock.deuda}
            crecimiento={stock.crecimiento}
            margenes={stock.margenes}
            NetRevenue={stock.NetRevenue}
            GrossProfit={stock.GrossProfit}
            OperatingExpenses={stock.OperatingExpenses}
            OperatingIncome={stock.OperatingIncome}
            Assets={stock.Assets}
            NetIncome={stock.NetIncome}
            Shares={stock.Shares}
            EBIT={stock.EBIT}
            FCF={stock.FCF}
            DandA={stock.DandA}
            quity={stock.Equity}
            Debt={stock.Debt}
            CashandEquivalents={stock.CashandEquivalents}
          />
        ))}
    </Box>
  );
};

export default Analisis;
